module.exports = __webpack_public_path__ + "img/left_top.7bfcc94e.png";